"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_FONT_WEIGHT = exports.TEXT_FONT_SIZE = exports.TEXT_COLOR = exports.MAX_WIDTH_DESKTOP = exports.MAX_HOVER_DELAY_DURATION = exports.MARGIN_MOBILE = exports.BREAKPOINT = void 0;
var MAX_WIDTH_DESKTOP = 400;
exports.MAX_WIDTH_DESKTOP = MAX_WIDTH_DESKTOP;
var MARGIN_MOBILE = 16;
exports.MARGIN_MOBILE = MARGIN_MOBILE;
var BREAKPOINT = MAX_WIDTH_DESKTOP + MARGIN_MOBILE * 2;
exports.BREAKPOINT = BREAKPOINT;
var MAX_HOVER_DELAY_DURATION = 2000;
exports.MAX_HOVER_DELAY_DURATION = MAX_HOVER_DELAY_DURATION;
var TEXT_FONT_SIZE = 'T100';
exports.TEXT_FONT_SIZE = TEXT_FONT_SIZE;
var TEXT_FONT_WEIGHT = 'regular';
exports.TEXT_FONT_WEIGHT = TEXT_FONT_WEIGHT;
var TEXT_COLOR = 'neutral90';
exports.TEXT_COLOR = TEXT_COLOR;